import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  DateCTA,
  NewDateFIlterModal as DateFilterModal,
  Loader,
} from "components";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { useSelector } from "react-redux";
import { getChartWidth, getPercentageChange } from "utils/helper";
import {
  getRegisteredAgentsStats,
  setRegisteredDates,
} from "redux/actions/dashboard/onboardingDashboardActions";
// import { exportComponentAsJPEG } from "react-component-export-image";
// import downloadImg from "assets/images/download-img.svg";

const RegisteredChart = React.forwardRef((props, ref) => {
  const { userType, registered } = useSelector(
    (state) => state.onboardingReducer
  );

  const typeOfUser = userType.toLowerCase() + "s";

  const { data, loading } = registered || {};

  return (
    <div className="chart mt-3 px-4" ref={ref}>
      {loading ? (
        <div className={" text-center mtop-4"}>
          <Loader />
          <Typography state="grey" variant="body2">
            Loading data...
          </Typography>
        </div>
      ) : data?.breakdown?.length && !data.isError ? (
        <ResponsiveContainer
          width={getChartWidth(data?.breakdown?.length)}
          height="100%"
        >
          <BarChart
            width={730}
            height={250}
            data={data?.breakdown}
            margin={{ left: -15, bottom: 20 }}
          >
            <XAxis
              dataKey="label"
              dy={15}
              axisLine={false}
              tickSize={0}
              minTickGap={0}
              style={{
                fontSize: "11px",
                fontWeight: 500,
                fontFamily: "Work Sans",
                color: "#778CA2",
              }}
            />
            <YAxis
              style={{
                fontSize: "12px",
                fontFamily: "Work Sans",
                color: "#778CA2",
              }}
              axisLine={false}
              tickSize={0}
              dx={-10}
            />
            <CartesianGrid
              strokeDasharray="10 10"
              vertical={false}
              stroke="#f5f5f5"
            />
            <Bar
              dataKey="count"
              fill={
                userType === "AGGREGATOR" ? "rgba(98, 60, 234, 0.2)" : "#DDE8FF"
              }
              barSize={26}
              radius={[5, 5, 5, 5]}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography
          state="grey"
          variant="body2"
          className={"text-center mtop-4"}
        >
          No registered {typeOfUser} within selected dates
        </Typography>
      )}
    </div>
  );
});

const RegisteredAgents = () => {
  const componentRef = useRef();
  const { userType, registered } = useSelector(
    (state) => state.onboardingReducer
  );

  const [openDateModal, setOpenDateModal] = useState(false);

  const handleModalClose = () => setOpenDateModal(false);

  const getAgentsData = () => {
    getRegisteredAgentsStats(userType, dates);
    handleModalClose();
  };

  useEffect(() => {
    getAgentsData();

    //eslint-disable-next-line
  }, [userType]);

  const typeOfUser = userType.toLowerCase() + "s";

  const { data, loading, dates } = registered || {};

  const { change, img, value, indicator } = getPercentageChange(data?.change);

  return (
    <React.Fragment>
      <div className="agent-commission-chart">
        <div className="px-3 py-2 chart-info-card dashboard-card dashboard-card--radius-20">
          <div className="d-flex justify-content-between align-items-center">
            <Typography state="grey" variant="caption2">
              Registered {typeOfUser}
            </Typography>
            <DateCTA onClick={() => setOpenDateModal(true)} />
          </div>
          <Typography variant="subtitle1" state="primary" className={"mt-1"}>
            {data?.totalCount}
          </Typography>
          {!loading &&
            !data.isError &&
            (change ? (
              <Typography component="span" variant="caption0">
                0% Change
              </Typography>
            ) : (
              value && (
                <div className="mt-3">
                  <img src={img} alt="" /> &nbsp;
                  <Typography component="span" variant="caption0">
                    {value} {indicator} {typeOfUser}
                  </Typography>
                </div>
              )
            ))}
        </div>
        <div className="agent-commission-chart-container dashboard-card">
          <RegisteredChart ref={componentRef} />
          {/* <div className="d-flex justify-content-end chart-download-cta">
            <img
              src={downloadImg}
              alt="download"
              onClick={() => exportComponentAsJPEG(componentRef)}
            />
          </div> */}
        </div>
        <DateFilterModal
          dateFrom={dates.dateFrom}
          dateTo={dates.dateTo}
          openDateModal={openDateModal}
          onClose={handleModalClose}
          handleFromChange={(val) => setRegisteredDates(val, "dateFrom")}
          handleToChange={(val) => setRegisteredDates(val, "dateTo")}
          onButtonClick={getAgentsData}
        />
      </div>
    </React.Fragment>
  );
};

export default RegisteredAgents;
